import { render, staticRenderFns } from "./Outlets.vue?vue&type=template&id=4c21fd10&scoped=true&"
import script from "./Outlets.vue?vue&type=script&lang=js&"
export * from "./Outlets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21fd10",
  null
  
)

export default component.exports